export const AI_SERVICE_BASE_URL = '/api/generative-ai';
